import React from "react";
import { useQuery } from "@apollo/client";
import { Navigate } from "react-router-dom";
import CurrentUser from "../queries/CurrentUser";

const RequireReports = (WrappedComponent) => {
  const AuthenticatedComponent = () => {
    const { loading, error, data } = useQuery(CurrentUser);

    if (loading) return null;

    if (error) {
      console.log(error);
      return <p>Something Went Wrong...</p>;
    }

    if (!data?.currentUser) {
      return <Navigate to="/login" replace />;
    }

    if (
      data.currentUser.role !== "admin" &&
      data.currentUser.role !== "report_viewer"
    ) {
      return <Navigate to="/dashboard" replace />;
    }

    return <WrappedComponent currentUser={data.currentUser} />;
  };

  return <AuthenticatedComponent />;
};

export default RequireReports;
